<div mat-dialog-title style="position: relative;">
    <h3>Switch User</h3>
    <button style="position: absolute; top: 0; right: 0;" mat-dialog-close mat-button tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
    <hr class="divider">
</div>

<div mat-dialog-content>
    <form [formGroup]="formGroup" name="switchUserForm" id="switchUserForm" novalidate action="/login/impersonate"
          method="post">
        <app-question [question]="userQuestion"></app-question>
        <input type="text" hidden name="username" [formControl]="controls.user">
    </form>
    <app-button-list>
        <app-button [loading]="loading" [disabled]="!formGroup.valid" (clickedEvent)="onSubmit()">Switch User
        </app-button>
    </app-button-list>
</div>
